import React, { useState, useEffect, useContext } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import { FormControl, Box, Typography, Paper, Chip } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Modal } from '../../../components/BootstrapToMUI';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import { useTheme } from '@mui/material/styles';
import { useForm, Controller } from 'react-hook-form';

export default function CreateGroup(props) {
  const theme = useTheme();
  const createGroupURL = `/groups/create`;
  const updateGroupURL = `/groups/update/`;
  const getMyMachineURL = `/machines/getMyMachines/`;
  const getAllEmployeesURL = `/users/getAllEmployees/`;

  const title = props.update === 'false' ? 'Create a Group' : 'Update Group';
  const button = props.update === 'false' ? 'Create Group' : 'Update Group';

  const {
    checkedvalues,
    setcheckedvalues,
    checkedvalues2,
    setcheckedvalues2,
    name,
    groupid,
    reflesh,
    setreflesh,
    id,
    setname,
    ...rest
  } = props;

  const [machine, setMachine] = useState([]);
  const [employees, setEmployees] = useState([]);

  const defaultValues = {
    Name: name,
    machineID: checkedvalues,
    userID: checkedvalues2,
  };

  const {
    reset,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  function handleSelect(checkedId) {
    const newIds = checkedvalues?.includes(checkedId)
      ? checkedvalues?.filter((name) => name !== checkedId)
      : [...(checkedvalues ?? []), checkedId];
    setcheckedvalues(newIds);
    return newIds;
  }

  function handleSelect2(checkedId) {
    const newIds = checkedvalues2?.includes(checkedId)
      ? checkedvalues2?.filter((name) => name !== checkedId)
      : [...(checkedvalues2 ?? []), checkedId];
    setcheckedvalues2(newIds);
    return newIds;
  }

  useEffect(() => {
    reset(defaultValues);
    let isCancelled = false;
    //getAllEmployees

    async function getMyMachines() {
      await request({
        method: 'get',
        url: getMyMachineURL + id,
      }).then((res) => {
        if (!isCancelled) {
          setMachine(res.data);
        }
      });
    }

    async function getMyUser() {
      await request({
        method: 'get',
        url: getAllEmployeesURL + id,
      }).then((res) => {
        if (!isCancelled) {
          setEmployees(res.data);
        }
      });
    }

    getMyMachines();
    getMyUser();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const onSubmit = async (data) => {
    console.log(data);
    if (props.update === 'false') {
      await request({
        method: 'post',
        url: createGroupURL,
        data: {
          name: data.Name,
          machineID: data.machineID,
          userID: data.userID,
          referTo: id,
        },
      }).then((res) => {
        props.onHide();
        props.setreflesh(reflesh ? false : true);
        Swal.fire({
          text: `New group has been successfully created: ${data.Name}`,
          icon: 'success',
        });
      });
    }
    if (props.update === 'true') {
      await request({
        method: 'patch',
        url: updateGroupURL + groupid,
        data: {
          name: data.Name,
          machineID: data.machineID,
          userID: data.userID,
          referTo: id,
        },
      }).then((res) => {
        props.onHide();
        props.setreflesh(reflesh ? false : true);
        Swal.fire({
          text: `New group has been successfully updated: ${data.Name}`,
          icon: 'success',
        });
      });
    }
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          sx={{ fontSize: '1.2rem', fontWeight: 600 }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body" sx={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          <Box sx={{ px: 2, py: 1 }}>
            {/* Group Name */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, fontSize: '0.95rem' }}>
                Group Information
              </Typography>
              <Controller
                name="Name"
                control={control}
                rules={{ required: 'Name is required' }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="Group Name"
                    variant="outlined"
                    required
                    size="small"
                    sx={{ maxWidth: 400 }}
                    defaultValue={name}
                    onChange={onChange}
                    error={!!errors.Name}
                    helperText={errors.Name?.message}
                  />
                )}
              />
            </Box>

            {/* Select Machines and Users - Side by Side */}
            <Grid container spacing={2}>
              {/* Select Machines */}
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    height: '100%',
                    backgroundColor:
                      theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                    borderRadius: 1.5,
                  }}
                >
                  <FormControl fullWidth>
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        mb: 1,
                        color: theme.palette.text.primary,
                      }}
                    >
                      Select Machines
                    </FormLabel>
                    {errors.machineID && (
                      <Typography color="error" variant="caption" sx={{ mb: 1 }}>
                        {errors.machineID.message}
                      </Typography>
                    )}
                    <Box>
                      <Grid container spacing={0.5}>
                        <Controller
                          name="machineID"
                          rules={{ required: 'At least one machine is required' }}
                          render={({ field }) =>
                            machine.map((item) => (
                              <Grid item xs={12} key={item._id}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      onChange={() => field.onChange(handleSelect(item._id))}
                                      checked={checkedvalues.includes(item._id)}
                                    />
                                  }
                                  label={
                                    <Typography sx={{ fontSize: '0.875rem' }}>
                                      {item.name} - {item.description}
                                    </Typography>
                                  }
                                />
                              </Grid>
                            ))
                          }
                          control={control}
                        />
                      </Grid>
                    </Box>
                  </FormControl>
                </Paper>
              </Grid>

              {/* Select Users */}
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    height: '100%',
                    backgroundColor:
                      theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                    borderRadius: 1.5,
                  }}
                >
                  <FormControl fullWidth>
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        mb: 1,
                        color: theme.palette.text.primary,
                      }}
                    >
                      Select Users
                    </FormLabel>
                    <Box>
                      <Grid container spacing={0.5}>
                        <Controller
                          name="userID"
                          render={({ field }) =>
                            employees.map((item) => (
                              <Grid item xs={12} key={item._id}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      size="small"
                                      onChange={() => field.onChange(handleSelect2(item._id))}
                                      checked={checkedvalues2.includes(item._id)}
                                    />
                                  }
                                  label={
                                    <Typography sx={{ fontSize: '0.875rem' }}>
                                      {item.lastname} {item.firstname} ({item.email})
                                    </Typography>
                                  }
                                />
                              </Grid>
                            ))
                          }
                          control={control}
                        />
                      </Grid>
                    </Box>
                  </FormControl>
                </Paper>
              </Grid>
            </Grid>

            {/* Submit Button */}
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  minWidth: 180,
                  py: 1.2,
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  textTransform: 'none',
                }}
              >
                {button}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
